var cartNoteTyping;

validateQty = function (qty) {
  if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

$(document).on("keydown", "[name=note]", function (e) {
  clearTimeout(cartNoteTyping);
});

$(document).on("keyup ", "[name=note]", function (evt) {
  var _this = $(this);
  clearTimeout(cartNoteTyping);
  cartNoteTyping = setTimeout(function () {
    var currentVal = _this.val();
    $.ajax({
      url: cartUpdateUrl,
      type: "POST",
      data: { note: currentVal },
      dataType: "json",
      success: function (result) {},
    });
  }, 750);
});

if (window.location.pathname.indexOf("/cart") > -1) {
  setTimeout(function () {
    $.ajax({
      url: mainCartUrl,
      type: "GET",
      dataType: "json",
      success: function (result) {
        if (result.item_count > 0) {
          upsellCartProducts(result);
        }
      },
    });
  }, 500);

  // Update quantity based on input on change

  changeCartItem = function (line, quantity) {
    var params = {
      type: "POST",
      url: cartChangeUrl,
      data: "quantity=" + quantity + "&line=" + line,
      dataType: "json",
      success: function (cart) {
        if (cart.item_count == 0) {
          emptyCartStatus = true;
          $("[data-cart-count]").hide();
        } else {
          emptyCartStatus = false;
          cartItemsCount = cart.item_count;
          $("[data-cart-count]").show();

          var item = cart.items[line - 1];
          if (item) {
            $('[name="updates[]"][data-line="' + line + '"]').val(
              item.quantity
            );
          }
        }
        cartPageUpdate(cart);
      },
      error: function (XMLHttpRequest, textStatus) {
        jQuery.getJSON(cartUrl, function (cart, textStatus) {
          if (quantity == 0) {
            $('[name="updates[]"][data-line="' + line + '"]')
              .closest("tr")
              .remove();
          }
          cartItemsCount = cart.item_count;
          if (cart.item_count == 0) {
            $("[data-cart-count]").hide();
          } else {
            $("[data-cart-count]").show();

            var item = cart.items[line - 1];
            if (item) {
              $('[name="updates[]"][data-line="' + line + '"]').val(
                item.quantity
              );
            }
          }
          cartPageUpdate(cart);
        });
      },
    };
    jQuery.ajax(params);
  };

  $(document).on("click", ".line_item_change", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      $qtySelector = $el.siblings('input[name="updates[]"]');

    $("#cartItemError-" + line).html("");
    var qty = parseInt($qtySelector.val().replace(/\D/g, ""));

    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");
    var qty = validateQty(qty);

    if ($el.hasClass("quantity-up")) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
    }
    $qtySelector.val(qty);
    if (line) {
      changeCartItem(line, qty);
    }
  });

  $(document).on("change", '[name="updates[]"]', function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      qty = parseInt($el.val().replace(/\D/g, ""));
    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");

    $("#cartItemError-" + line).html("");
    qty = validateQty(qty);
    // Add or subtract from the current quantity

    if (line) {
      changeCartItem(line, qty);
    }
  });

  $(document).on("click", ".line_item_remove", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      parent = $el.closest("tr"),
      line = $el.data("line");
    // If it has a data-line, update the cart
    if (line) {
      parent.addClass("disabled");
      parent.closest("[data-cart-items]").addClass("disabled");
      changeCartItem(line, 0);
    }
  });
} else {
  // POST to cart/change.js returns the cart in JSON
  changeItem = function (line, quantity, callback) {
    var $body = $(document.body),
      params = {
        type: "POST",
        url: cartChangeUrl,
        data: "quantity=" + quantity + "&line=" + line,
        dataType: "json",
        success: function (cart) {
          if (cart.item_count == 0) {
            emptyCartStatus = true;
            $("[data-cart-count]").hide();
          } else {
            emptyCartStatus = false;
            $("[data-cart-count]").show();
          }
          var item = cart.items[line - 1];
          if (item) {
            $(
              '.ajaxcart__qty-num[name="updates[]"][data-line="' + line + '"]'
            ).val(item.quantity);
          }
          callback(cart);
        },
        error: function (XMLHttpRequest, textStatus) {
          jQuery.getJSON(cartUrl, function (cart, textStatus) {
            callback(cart);
          });
        },
      };
    jQuery.ajax(params);
  };

  updateQuantity = function (line, qty, callback) {
    isUpdating = true;
    setTimeout(function () {
      changeItem(line, qty, callback);
    }, 250);
  };

  function getvaluefromdataattribute(name) {
    return $('input[data-attr="' + name + '"]').val();
  }

  $("#Recipient-Checkbox").click(function () {
    if (!this.checked) {
      $('input[data-attr="' + "email" + '"]').val("");
      $('input[data-attr="' + "name" + '"]').val("");
    }
  });

  if (cartDrawerEnable) {
    // POST to cart/add.js returns the cart in JSON
    $("body").on("click", ".Sd_addProduct", function (evt) {
      evt.preventDefault();
      
      let submit = $(this);
      let form = $(this).closest("form");
      submit.addClass("is-loading");
      if (submit.hasClass("Sd_addProductSticky")) {
        form = jQuery("#" + submit.attr("form"));
      }

      // Get the product ID from the form
      const productId = form.find('input[name="id"]').attr("data-product-id");

      $.getJSON(cartUrl, function (cart) {
        const isProductInCart = cart.items.some(
          (item) => item.product_id === parseInt(productId)
        );

        if (isProductInCart) {
          showNotice(cardDupeTitle, cardDupeMessage, "error");
          submit.removeClass("is-loading");
          return false;
        }

        // Product not in cart - proceed with normal add to cart
        if (form.closest(".yv_side_drawer_wrapper").length == 0) {
          focusElement = submit;
        }
        let parentSection = form.closest(".shopify-section");
        var Email = $('input[data-attr="' + "email" + '"]').val();
        $('input[data-attr="' + "email" + '"]').val("");
        $('input[data-attr="' + "name" + '"]').val("");
        parentSection.find(".productErrors").hide().html("");


        if (form.closest(".yv_side_drawer_wrapper").length == 0) {
          $("[data-drawer-body]").html(preLoadLoadGif);
          $("body")
            .find("[data-side-drawer]")
            .attr("class", "yv_side_drawer_wrapper");
          $("body").find("[data-drawer-title]").html(cartTitleLabel);
          $("body").find("[data-side-drawer]").attr("id", "mini__cart");
          $("body").find("[data-side-drawer]").addClass("mini_cart");
        }

        params = {
          type: "POST",
          url: cartAddUrl,
          data: form.serialize(),
          dataType: "json",
          success: function (line_item) {
            if (form.closest(".quick-add-popup").length > 0) {
              form.closest(".quick-add-popup")[0].classList.remove("show");
              form.closest("[quick-add-body]")[0].innerHTML = "";
              document.body.classList.remove("quick-add-popup-open");
            }
            if (form.closest(".yv_side_drawer_wrapper").length > 0) {
              $("[data-drawer-body]").html(preLoadLoadGif);
              $("body")
                .find("[data-side-drawer]")
                .attr("class", "yv_side_drawer_wrapper");
              $("body").find("[data-drawer-title]").html(cartTitleLabel);
              $("body").find("[data-side-drawer]").attr("id", "mini__cart");
              $("body").find("[data-side-drawer]").addClass("mini_cart");
            }

            $("body").removeClass("quickview-open");
            $("body").addClass("side_Drawer_open");
            if (hapticFeedbackStatus) {
              const canVibrate = window.navigator.vibrate;
              if (canVibrate) window.navigator.vibrate(500);
            }
            jQuery.getJSON(cartUrl, function (cart, textStatus) {
              buildCart(cart, true);
              setTimeout(function () {
                submit.removeClass("is-loading");
              }, 1000);
            });
          },
          error: function (XMLHttpRequest, textStatus) {
            focusElement = "";
            if (typeof errorCallback === "function") {
              errorCallback(XMLHttpRequest, textStatus);
            } else {
              let errorContainer = parentSection.find(".productErrors");
              if (errorContainer.length > 0) {
                if (XMLHttpRequest.responseJSON.errors) {
                  let giftCardWrapper = form.find("[data-gift-card-box]");
                  if (
                    giftCardWrapper.length > 0 &&
                    XMLHttpRequest.responseJSON.errors["email"]
                  ) {
                    let errormessageWrapper = giftCardWrapper.find(
                      "[data-gift-card-errors]"
                    );
                    let giftCardEmail = giftCardWrapper.find("[type=email]");
                    errorContainer
                      .html(
                        giftCardEmail.attr("data-attr") +
                          " " +
                          XMLHttpRequest.responseJSON.errors["email"]
                      )
                      .show();
                  }
                } else {
                  errorContainer
                    .text(XMLHttpRequest.responseJSON.description)
                    .show();
                }
              }
            }
            setTimeout(function () {
              $(".Sd_addProductSticky").removeClass("is-loading");
              submit.removeClass("is-loading");
            }, 1000);
          },
        };
        jQuery.ajax(params);
      });
    });

    // Update quantity based on input on change

    $(document).on("click", ".quantity-button", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = $el.data("line"),
        $qtySelector = $el.closest(".quantity").find(".ajaxcart__qty-num");
      var qty = $qtySelector.val();
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      if (qty) {
        qty = parseInt(qty.replace(/\D/g, ""));
      }

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      $qtySelector.val(qty);
      if (line) {
        updateQuantity(line, qty, buildCart);
      }
    });

    // Update quantity based on input on change
    $(document).on("change", ".ajaxcart__qty-num", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = $el.data("line"),
        qty = parseInt($el.val().replace(/\D/g, ""));

      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty, buildCart);
      }
    });

    function openCartDrawer(element) {
      $("[data-drawer-body]").html(preLoadLoadGif);
      $("body").find("[data-drawer-title]").html(cartTitleLabel);
      $("body")
        .find("[data-side-drawer]")
        .attr("class", "yv_side_drawer_wrapper");
      $("body")
        .find("[data-side-drawer]")
        .attr("id", "mini__cart")
        .addClass("mini_cart");
      $("body").addClass("side_Drawer_open");
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        buildCart(cart, true, element);
      });
      window.__DL__ = {...window.__DL__, isDrawerOpen : true}
    }
    $("body").on("click", ".openCartDrawer", function (e) {
      e.preventDefault();
      openCartDrawer($(this));
    });

    $("body").on("keydown", ".openCartDrawer", function (e) {
      if (e.code.toUpperCase() === "SPACE") {
        e.preventDefault();
        openCartDrawer($(this));
      }
    });

    $(document).on("click", ".sd_mini_removeproduct", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = parseInt($el.attr("data-line"));
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, 0, buildCart);
      }
    });

    $(document).on("click ", ".cartDrawerNote", function (evt) {
      $(this).toggleClass("active");
      var textArea = $(this).siblings(".cartNoteContainer");
      textArea.slideToggle();
    });
  }
}

$("body").on("click", "#GiftWrapProduct", function () {
  params = {
    type: "POST",
    url: cartAddUrl,
    data: { id: parseInt($(this).attr("data-product")), quantity: 1 },
    dataType: "json",
    success: function (line_item) {
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        if (window.location.pathname.indexOf("/cart") > -1) {
          cartPageUpdate(cart);
        } else {
          buildCart(cart, true);
        }
      });
    },
    error: function (XMLHttpRequest, textStatus) {
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        if (window.location.pathname.indexOf("/cart") > -1) {
          buildCart(cart, true);
        } else {
          cartPageUpdate(cart);
        }
      });
    },
  };
  jQuery.ajax(params);
});

cartPageUpdate = function (cart) {
  $.ajax({
    url: mainCartUrl,
    type: "GET",
    dataType: "html",
    success: function (result) {
      $("body")
        .find("[data-cart-wrapper]")
        .html($(result).find("[data-cart-wrapper]").html());
      $(".cart-section").find("a:first").trigger("focus");
      upsellCartProducts(cart);
      if (animationStatus) {
        if (AOS) {
          AOS.refreshHard();
        }
      }
    },
  });
};

buildCart = function (cart, showCart, element) {
  if (cart.item_count === 0) {
    emptyCartStatus = true;
    $("[data-cart-count]").hide();
  } else {
    emptyCartStatus = false;
    $("[data-cart-count]").show();
  }
  cartItemsCount = cart.item_count;
  if (cartItemsCount > 0 && cartItemsCount < 100) {
    $("[data-cart-count]").text(cart.item_count);
  } else {
    $("[data-cart-count]").text("");
  }
  $("[data-drawer-body]").load(mainCartUrl + "?view=jsonData", function () {
    upsellCartDrawerProducts(cart, "drawer");
    if (showCart) {
      $("body").addClass("yv_side_Drawer_open");
      $(".wrapper-overlay").css({ display: "block" });
      focusElementsRotation($("[data-side-drawer]"));
      if (element) {
        focusElement = element;
      }
      $(document).find(".yv_side_drawer_wrapper").trigger("focus");
    }
    if (animationStatus) {
      if (AOS) {
        AOS.refreshHard();
      }
    }
  });
};

$(document).on("click", "[data-drawer-side-header]", function () {
  if ($(this).closest(".yv-upsell-drawer").hasClass("active")) {
    $(this).closest(".yv-upsell-drawer").removeClass("active");
  } else {
    $(this).closest(".yv-upsell-drawer").addClass("active");
  }
});

function upsellCartDrawerProducts(cart) {
  if (cart.item_count != 0) {
    if (document.querySelector("[data-drawer-side-content]")) {
      let upsellContainer = document.querySelector(
        "[data-drawer-side-content]"
      );
      let intent = upsellContainer.getAttribute("data-related-products");
      if (intent != "product-list") {
        let productId = cart.items[0].product_id;
        let limit = upsellContainer.getAttribute("data-limit");
        fetch(
          window.Shopify.routes.root +
            "recommendations/products?product_id=" +
            productId +
            "&limit=" +
            limit +
            "&section_id=upsell-products&intent=" +
            intent
        )
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector(
              "#product-recommendations"
            );
            if (recommendations && recommendations.innerHTML.trim().length) {
              upsellContainer.innerHTML = recommendations.innerHTML;
              document
                .querySelector(".yv-upsell-drawer")
                .classList.remove("hidden");
            } else {
              document
                .querySelector(".yv-upsell-drawer")
                .classList.add("hidden");
            }
          });
      } else {
        if (upsellContainer.children.length > 0) {
          document
            .querySelector(".yv-upsell-drawer")
            .classList.remove("hidden");
        } else {
          document.querySelector(".yv-upsell-drawer").classList.add("hidden");
        }
      }
    }
  }
}

function upsellCartProducts(cart) {
  if (cart.item_count != 0) {
    if (document.querySelector("[data-cart-upsell-wrapper]")) {
      let upsellWrapper = document.querySelector("[data-cart-upsell-wrapper]");
      let upsellContainer = upsellWrapper.querySelector("[data-cart-upsell]");
      let intent = upsellWrapper.getAttribute("data-related-products");
      if (intent != "product-list") {
        let productId = cart.items[0].product_id;
        let limit = upsellWrapper.getAttribute("data-limit");
        fetch(
          window.Shopify.routes.root +
            "recommendations/products?product_id=" +
            productId +
            "&limit=" +
            limit +
            "&section_id=upsell-products&intent=" +
            intent
        )
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector(
              "#product-recommendations"
            );
            if (recommendations && recommendations.innerHTML.trim().length) {
              if (window.innerWidth >= 768) {
                if (upsellContainer.classList.contains("flickity-enabled")) {
                  let slider = Flickity.data(upsellContainer);
                  if (slider) {
                    slider.destroy();
                    upsellContainer.innerHTML = recommendations.innerHTML;
                    upsellWrapper.classList.remove("hidden");
                    flickitySlider(jQuery(upsellContainer));
                  }
                } else {
                  upsellContainer.innerHTML = recommendations.innerHTML;
                  upsellWrapper.classList.remove("hidden");
                  flickitySlider(jQuery(upsellContainer));
                }
              } else {
                upsellContainer.innerHTML = recommendations.innerHTML;
                upsellWrapper.classList.remove("hidden");
              }
            } else {
              upsellWrapper.classList.add("hidden");
            }
          });
      } else {
        if (upsellContainer.classList.contains("flickity-enabled")) {
          let slider = Flickity.data(upsellContainer);
          if (slider) {
            slider.destroy();
          }
        }
        if (upsellContainer.children.length > 0) {
          if (window.innerWidth >= 768) {
            upsellWrapper.classList.remove("hidden");
            flickitySlider(jQuery(upsellContainer));
          } else {
            upsellWrapper.classList.remove("hidden");
          }
        } else {
          upsellWrapper.classList.add("hidden");
        }
      }
    }
  }
}
